import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderBottom from "../../components/HomePage/HeaderBottom";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 3;

  useEffect(() => {
    fetch("https://healthkeywordresearch01-5ec078e699df.herokuapp.com/posts")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((error) => console.error("Error fetching posts:", error));
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <>
      <HeaderBottom></HeaderBottom>

      {/*===== WELCOME STARTS =======*/}
      <div
        className="about-welcome-section-area about2"
        style={{
          backgroundImage: "url()",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="about-welcome-header text-center py-5">
                <h1 className="fw-bold display-5 text-dark">All Blog Posts</h1>
                <div className="mb-3"></div>
                <a href="/" className="text-decoration-none text-muted fs-5">
                  Home <i className="fa-solid fa-angle-right mx-1"></i> <span className="text-primary">Blog</span>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/*===== WELCOME ENDS =======*/}

      <main className="main-wrapper min-vh-100 bg-light">
        <div className="blog1-section-area py-5">
          <div className="container">
            <div className="row g-4">
              {currentPosts.map((post, index) => (
                <div
                  key={post._id}
                  className="col-lg-4 col-md-6 d-flex"
                  data-aos="zoom-out"
                  data-aos-duration={800 + index * 200}
                >
                  <div className="card border-0 shadow-lg rounded-3 overflow-hidden h-100 d-flex flex-column">
                    <Link to={`/blog/${post.titleSlug}`}>
                      <img
                        src={post.featuredImage}
                        alt="Blog Thumbnail"
                        className="card-img-top"
                        style={{ height: "250px", objectFit: "cover", width: "100%" }}
                      />
                    </Link>
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <img
                          src="https://i.ibb.co.com/qYkZdbKQ/calendar-249.png"
                          alt="Calendar"
                          className="me-2"
                          style={{ width: "20px" }}
                        />
                        <span className="text-muted small">{post.postDate}</span>
                      </div>
                      <h3 className="">
                        <Link
                          to={`/blog/${post.titleSlug}`}
                          className="text-dark text-decoration-none"
                        >
                          {post.postTitle}
                        </Link>
                      </h3>
                      <div className="mt-auto">
                        <Link to={`/blog/${post.titleSlug}`} className="btn btn-primary btn-sm">
                          Read More <i className="fa-solid fa-arrow-right ms-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {posts.length > postsPerPage && (
              <div className="text-center mt-4">
                <button
                  className="btn btn-dark px-4 py-2"
                  onClick={() =>
                    setCurrentPage((prev) =>
                      prev < Math.ceil(posts.length / postsPerPage) ? prev + 1 : prev
                    )
                  }
                >
                  View More Blogs <i className="fa-solid fa-arrow-right ms-2" />
                </button>
              </div>
            )}
          </div>
        </div>
      </main>

    </>
  );
};

export default Blog;
